import React, { useEffect } from 'react';
import '../css/month-buttons.css'
// import { functionContext } from '../app'
import { useHistory } from "react-router-dom";

function MonthButtons({ handleYearChange, selectedMonth, changeSelectedMonth, currentYear, currentMonth }) {

  // const {  } = useContext(functionContext);
  const history = useHistory()

  function addClassFirstRender(selectedMonth) {
    let allButtons = document.getElementsByClassName("month-button")
    for (let i = 0; i < allButtons.length; i++) {
      allButtons[i].classList.remove("month-selected")
    }
    let firstRenderButton = document.getElementById(`month-button-${selectedMonth}`)
    firstRenderButton.classList.add("month-selected")
  }

  function handleClick(e) {
    let currentlySelectedMonth = e.currentTarget.id.substr(13, 2)
    changeSelectedMonth(currentlySelectedMonth)
    removeActiveClasses(e)
    addActiveClass(e)
    history.push("/");
  }

  function removeActiveClasses(e) {
    let allButtons = document.getElementsByClassName("month-button")
    let todayDay = document.getElementsByClassName("today")

    for (let i = 0; i < allButtons.length; i++) {
      allButtons[i].classList.remove("month-selected")
    }

    for (let i = 0; i < todayDay.length; i++) {
      todayDay[i].classList.remove("today")
    }
  }

  function addActiveClass(e) {
    e.currentTarget.classList.add("month-selected")
  }

  useEffect(() => {
    addClassFirstRender(selectedMonth);
    }, [selectedMonth]);



useEffect(() => {
  changeSelectedMonth( currentMonth ) ;
  }, []);

  return (
    <>
      <div id="month-buttons">
        <input onChange={(e)=> handleYearChange((e.currentTarget.value))} className="setyear-input" type="text" 
        placeholder="Enter Year..."
        value={currentYear} >
        </input>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-1">January</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-2">February</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-3">March</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-4">April</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-5">May</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-6">June</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-7">July</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-8">August</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-9">September</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-10">October</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-11">November</button>
        <button onClick={(e) => handleClick(e)} className={`month-button`} id="month-button-12">December</button>
      </div>
    </>
  )
}

export default MonthButtons;
